import { createAction } from "@reduxjs/toolkit";
import type { UpdateStudentBody } from "@shared-kernel/application/ports/student/student-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const updateStudentProfile = createApiThunk<void, UpdateStudentBody>(
  "students/updateStudentProfile",
  async (body: UpdateStudentBody, { extra: { studentRepository } }) => {
    await studentRepository!.update(body);
  },
);

export const resetUpdateStudentProfile = createAction("students/resetUpdateStudentProfile");
